export default "__VITE_ASSET__DiyI2pcT__"